var map = {
	"./01.png": 71,
	"./02.png": 72,
	"./03.png": 73,
	"./04.png": 74,
	"./05.png": 75,
	"./06.png": 76,
	"./07.png": 77,
	"./08.png": 78,
	"./09.png": 79,
	"./10.png": 80,
	"./11.png": 81,
	"./12.png": 82,
	"./13.png": 83,
	"./14.png": 84,
	"./15.png": 85,
	"./16.png": 86,
	"./17.png": 87,
	"./18.png": 88,
	"./19.png": 89,
	"./20.png": 90,
	"./aax.jpeg": 91,
	"./alpaca.png": 92,
	"./binance.png": 93,
	"./coinbase.png": 94,
	"./ftx.png": 95,
	"./gateio.png": 96,
	"./kraken.png": 97,
	"./kucoin.jpeg": 98,
	"./upstox.png": 99,
	"./waves-exchange.png": 100,
	"./zerodha.png": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;